import { computed, getCurrentInstance, watch } from "@vue/composition-api";
import { AgeVerificationStatus } from "@scrile/api-provider/dist/api/AgeVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { ACTION_TYPES, MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import providers from "@/lib/api";

export default function useAgeVerification() {
  const vm = getCurrentInstance();
  const { authUser } = useAuthUser();

  const status = computed(() =>
    vm
      ? (vm.$store.state as StateRoot).ageVerificationStatus ?? AgeVerificationStatus.UNKNOWN
      : AgeVerificationStatus.UNKNOWN
  );
  const verified = computed(() => status.value === AgeVerificationStatus.APPROVED);

  const get = () => {
    if (!authUser.value) return;
    return vm?.$store.dispatch(ACTION_TYPES.GET_AGE_VERIFICATION_STATUS, authUser.value);
  };

  const reset = async () => {
    if (!authUser.value) return;
    const response = await providers.AgeVerificationProvider.reset({ userId: authUser.value.id });
    vm?.$store.commit(MUTATION_TYPES.SET_AGE_VERIFICATION_STATUS, response.status);
  };

  const onVerified = (cb: () => void) => {
    if (verified.value) return;
    const unWatch = watch(verified, () => {
      if (verified.value) {
        cb();
        unWatch();
      }
    });
  };

  return {
    status,
    verified,
    get,
    reset,
    onVerified,
  };
}
